<template>
  <div :class="['home', gonggeshow == 1 ? 'activeHome' : '']">
    <!-- v-if="delay" -->
    <AochenHead
      :InstanceList="InstanceList"
      :bannerList="bannerList"
      :countDownObj="countDownObj"
      @GroupList="GroupList"
      @updateGroup="getinstancelist"
      @signInClick="signInClick_father"
      v-if="delay"
    />
    <div class="main">
      <div v-if="gonggeshow == 1">
        <!-- v-if="delay" -->
        <Singlecard
          :gonggeshow="gonggeshow"
          :InstanceList="InstanceList"
          :buyShow="buyShow"
          :getShow="getShow"
          v-if="delay"
        />
      </div>
      <div v-if="gonggeshow == 4 || gonggeshow == 9 || gonggeshow == 16">
        <!-- v-if="delay" -->
        <Fourboxgrid
          :gonggeshow="gonggeshow"
          :InstanceList="InstanceList"
          :getShow="getShow"
        />
      </div>
    </div>
    <!-- 进入时的弹窗 -->
    <div class="remincla" v-if="reminder">
      <van-popup
        class="webImageImgPopup"
        :style="{ width: !reminder.imageUrl ? '80%' : '80%' }"
        v-model="reminder_show"
        v-if="reminder.imageUrl || reminder.content"
      >
        <div class="remi_img">
          <img
            class="webImageImg"
            v-if="reminder.imageUrl"
            :src="reminder.imageUrl"
            alt=""
            @click="remintz"
          />
          <div v-else class="remi_bt">
            <div class="remi_btP1">{{ reminder.title }}</div>
            <div class="remi_btP2" style="white-space: pre-wrap">
              {{ reminder.content }}
            </div>
          </div>
        </div>
        <div class="remi_guanbi" @click="reminder_show = false">
          <img src="../../assets/icons/guanbi.png" alt="" />
        </div>
      </van-popup>
    </div>
    <!-- <BgsSdk ref="child_BgsSdk" /> -->
    <AochenFooter></AochenFooter>
    <toAppStore :isTitle="true" ref="sonShow"></toAppStore>
    <SignInPopup
      :signInShow="signInShow"
      :signInObj="signInObj"
      @closeChildDialog="closeChildDialog"
      @getSignInlist="getSignInlist"
      v-if="delay"
    ></SignInPopup>
    <div v-if="countDownIconShow && new_group_buyShow != '1'">
      <!--   -->
      <div
        class="countDownOpenJump"
        @click="countDownJump"
        v-if="timeCountDown > 0"
      >
        <img
          class="closeCountDown"
          src="../../assets/img/activity/massiveGroupBuying/x.png"
          alt=""
          @click.stop="CountDownClose"
        />
        <van-count-down
          class="timeName"
          :time="timeCountDown"
          format="HH 时 mm 分 ss 秒"
        />
      </div>
      <!-- <div class="timeName">五一狂欢</div> -->

      <div class="countDownJump" @click="countDownJump" v-else>
        <img
          class="closeCountDown"
          src="../../assets/img/activity/massiveGroupBuying/x.png"
          alt=""
          @click.stop="CountDownClose"
        />
      </div>
    </div>
    <van-overlay :show="showGuide" z-index="9999">
      <div class="wrapper" @click.stop>
        <div class="describeBox">
          <div class="skipBox">
            <van-button
              class="skip"
              round
              type="default"
              @click="skipInstructions"
              >跳过引导</van-button
            >
          </div>
          <div class="name">设备转移功能上线啦，跟着引导前往转移</div>
          <van-button class="leaveFor" round type="info" @click="toMine"
            >前往转移</van-button
          >
          <img
            class="pointImg"
            src="../../assets/img/homeAmend/point_right.png"
            alt=""
          />
        </div>
        <div class="block" @click="toMine"></div>
      </div>
    </van-overlay>
    <dialogHint
      :dialogShow="dialogShow"
      :dialogTitle="dialogTitle"
      @dialogClic="confirms"
    >
      <template v-slot:content>{{ dialogName }}</template>
    </dialogHint>
    <van-popup
      class="channelErrorPopup"
      v-model="channelErrorShow"
      :close-on-click-overlay="false"
      ><div class="channelError">
        <div class="title">提示</div>
        <div>您用于注册的链接不完整，请重新复制完整注册链接。</div>
      </div></van-popup
    >
    <Loading v-model="showDialog"> </Loading>
  </div>
</template>

<script>
// @ is an alias to /src
import AochenFooter from "@/components/AochenFooter";
import AochenHead from "@/components/AochenHead";
import BgsSdk from "@/components/BgsSdk";
import Floating from "@/components/Floating.vue";
import Singlecard from "@/components/cell/Singlecard.vue";
import Fourboxgrid from "@/components/cell/Four_boxgrid.vue";
import SignInPopup from "@/components/cell/SignInPopup.vue";
import toAppStore from "@/components/activityGather/toAppStore.vue";
import dialogHint from "@/components/publicModule/dialogHint.vue";
import Loading from "@/components/publicModule/Loading.vue";

import {
  instancelist,
  activityreminder,
  regWelfare,
  groupAndRedData,
  sysConfigByConfigKey,
  signInlist,
  activityBanner,
  remoteLoginReminder,
  channelcodelist,
} from "../../api/index.js";
import { Toast } from "vant";
import { mapState, mapMutations } from "vuex";

export default {
  name: "HomeView",
  provide() {
    // 在爷爷组件中提供一个方法
    return {
      grandpaGetinstancelist: this.getinstancelist,
    };
  },
  components: {
    // 底部
    AochenFooter,
    // 头部
    AochenHead,
    // sdk
    BgsSdk,
    // sdk悬浮球
    Floating,
    // 单卡片内容区域
    Singlecard,
    // 4宫格
    Fourboxgrid,
    // 苹果跳appstore弹窗
    toAppStore,
    // 签到
    SignInPopup,
    dialogHint,
    Loading,
  },
  data() {
    return {
      integer: 0,
      InstanceList: [],
      groupingForList: [],
      userdata: null,
      reminder: null,
      reminder_show: false,
      gonggeshow: -1,
      flag: false,
      delay: false,
      buyShow: false,
      getShow: false,
      timer: null,
      signInShow: false,
      countDownObj: {},
      timeCountDown: 0,
      new_group_buyShow: "1",
      signInObj: {},
      isEnd: "1",
      showGuide: false,
      bannerList: [],
      dialogShow: false,
      dialogTitle: "温馨提示",
      dialogName: "",
      channelErrorShow: false,
      showDialog: false,
    };
  },
  created() {
    this.delay = true;

    // 从 Vuex 缓存中读取设备列表，避免白屏
    const cachedList = this.$store.state.common.instanceList;
    const cachedGrouping = this.$store.state.common.groupingForList;
    if (cachedList) {
      this.InstanceList = cachedList;
      this.groupingForList = cachedGrouping;
      this.getShow = true;
      if (this.InstanceList.length <= 0) {
        this.buyShow = true;
      } else {
        this.integer = 1;
      }
      const show = localStorage.getItem("homeMessage");
      this.gonggeqiehuan(show !== null ? Number(show) : 1);
    }
    // 从 Vuex 缓存中读取轮播图，避免白屏
    const cachedBanner = this.$store.state.common.bannerList;
    if (cachedBanner && cachedBanner.length > 0) {
      this.bannerList = cachedBanner;
    }
    // 从 Vuex 缓存中读取活动提示
    const cachedReminder = this.$store.state.common.reminder;
    if (cachedReminder) {
      this.reminder = cachedReminder;
      this.reminder_show = this.$store.state.common.reminderShow;
    }
  },
  mounted() {
    let that = this;
    // 缓存有效期（5秒），短时间内重复进入页面时跳过请求
    const CACHE_DURATION = 5 * 1000;
    const isCacheFresh =
      Date.now() - this.$store.state.common.homeDataFetchTime < CACHE_DURATION;
    if (!isCacheFresh) {
      that.getinstancelist();
      this.getActivityBanner();
    }
    let channelCode;
    if (that.$route.query.channelCode) {
      if (!isValidString(that.$route.query.channelCode)) {
        channelCode = { channelCode: atob(that.$route.query.channelCode) };
      } else {
        channelCode = {
          channelCode: that.$route.query.channelCode.replace(/"/g, ""),
        };
      }
      channelcodelist().then((res) => {
        if (res.code == 200) {
          // 是否与后台已经生成存在的渠道匹配
          const isFound = res.data.includes(channelCode.channelCode);
          if (!isFound) {
            this.channelErrorShow = true;
          } else {
            sessionStorage.setItem("channelCode", JSON.stringify(channelCode));
          }
        }
      });
    } else {
      let _channelCode = JSON.parse(sessionStorage.getItem("channelCode"));
      if (!_channelCode) {
        channelCode = { channelCode: "ac" };
        sessionStorage.setItem("channelCode", JSON.stringify(channelCode));
      }
    }
    function isValidString(str) {
      // 1. 判断字符串是否为空
      if (!str) {
        return false;
      }
      // 2. 判断是否以 'A' 开头 且 长度等于 4
      return str.startsWith("A") && str.length === 4;
    }
    if (Boolean(that.$route.query.applePush)) {
      this.SET_APPLEPUSHSHOW(Boolean(that.$route.query.applePush));
    }
    that.userdata = JSON.parse(localStorage.getItem("data"));
    if (that.userdata) {
      if (!isCacheFresh) {
        that.getactivityreminder();
      }
      if (this.recordLong) {
        that.getRegWelfare();
        if (this.$route.params.isSuccess) {
          remoteLoginReminder().then((res) => {
            if (res.data != "") {
              this.dialogName = res.data;
              this.dialogShow = true;
            }
          });
        }
      }
    }
    this.flag = true;
    let show = localStorage.getItem("homeMessage");
    if (show != null) {
      this.gonggeqiehuan(Number(show));
    } else {
      this.gonggeqiehuan(1);
    }
  },
  computed: {
    //数组写法
    ...mapState("common", ["recordLong", "applePushShow", "countDownIconShow"]),
  },
  methods: {
    confirms(msg) {
      this.dialogShow = msg;
    },
    toMine() {
      this.$router.push({ path: "/mine" });
      this.showGuide = false;
    },
    skipInstructions() {
      this.showGuide = false;
      localStorage.setItem("noviceGuideShow", true);
    },
    getSignInlist(callback) {
      signInlist().then((res) => {
        if (res.code == 200) {
          this.signInObj = res.data;
          this.signInObj.accumulateSignNumber = countWeekdaysWithValueOne(
            res.data
          );
          if (callback) callback();
        }
      });
      function countWeekdaysWithValueOne(dataObj) {
        // 定义要检查的字段名数组
        const weekDayFields = [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ];
        let count = 0;
        // 遍历字段数组并统计值为1的字段
        weekDayFields.forEach((field) => {
          if (dataObj[field] === 1) {
            count++;
          }
        });
        return count;
      }
    },
    getGroupBuying() {
      groupAndRedData().then((res) => {
        if (res.code == 200) {
          const countdownArr = res.data.groupBuying
            .filter((item) => item.isEnd == 0) // 过滤
            .map((item) => item.countdown)
            .sort(); // 取字段
          if (countdownArr.length > 0) {
            this.timeCountDown = countdownArr[0] * 1000;
          }
        }
      });
    },
    signInClick_father(e) {
      this.showDialog = true;
      this.getSignInlist(() => {
        this.showDialog = false;
        this.signInShow = e;
      });
    },
    closeChildDialog(e) {
      this.signInShow = e;
      this.getinstancelist();
    },
    ...mapMutations("common", [
      "SET_RECORDLONG",
      "SET_APPLEPUSHSHOW",
      "SET_COUNTDOWNICONSHOW",
      "SET_INSTANCELIST",
      "SET_GROUPINGFORLIST",
      "SET_BANNERLIST",
      "SET_HOMEDATA_FETCHTIME",
      "SET_REMINDER",
    ]),
    getRegWelfare() {
      let data = {};
      regWelfare(data).then((res) => {
        this.SET_RECORDLONG(false);
      });
    },
    // 切换宫格
    gonggeqiehuan(e) {
      // this.$nextTick(() => {
      this.gonggeshow = e;
      // sessionStorage.setItem("gonggeshow", e);
      // });
    },
    // 启动云手机
    BgsSdca(em) {
      this.userdata = JSON.parse(localStorage.getItem("data"));
      if (this.userdata) {
        // this.$refs.child_BgsSdk.getserverToken(em);
        let _em = this.groupingForList.find(function (item) {
          return item.id == em.id;
        });
        localStorage.setItem("em", JSON.stringify(_em));
        switch (_em.channelCode) {
          case "baidu":
            this.$router.push({
              params: {
                e: _em,
              },
              name: "BgsSdk",
            });
            break;
          case "huoshan":
            this.$router.push({
              params: {
                e: _em,
              },
              name: "VeSdk",
            });
            break;
          case "intelligent":
            this.$router.push({
              params: {
                e: _em,
              },
              name: "NzSdk",
            });
            break;
          case "huawei":
            this.$router.push({
              params: {
                e: _em,
              },
              name: "HwSdk",
            });
            break;
          case "tengxun":
            this.$router.push({
              params: {
                e: _em,
              },
              name: "TcgSdk",
            });
            break;
          default:
            console.log("0");
        }
      } else {
        this.$router.push("/login");
      }
    },
    // 轮播图
    getActivityBanner() {
      activityBanner().then((res) => {
        if (res.code == 200) {
          this.bannerList = res.data;
          this.SET_BANNERLIST(res.data);
          this.SET_HOMEDATA_FETCHTIME(Date.now());
        }
      });
    },
    // 获取所有设备信息
    async getinstancelist() {
      const list = JSON.parse(sessionStorage.getItem("selectiveGroup"));
      await instancelist()
        .then((res) => {
          const countDownShow = JSON.parse(
            sessionStorage.getItem("countDownShow")
          );
          const numGroup =
            JSON.parse(localStorage.getItem("homeMessage")) === 1;
          this.getShow = true;
          this.delay = true;
          if (res.code == 200) {
            this.groupingForList = res.data;
            this.SET_GROUPINGFORLIST(res.data);
            if (list === null || numGroup) {
              this.InstanceList = res.data;
              this.adjustGongge();
            } else {
              this.InstanceList = list.instanceList;
            }
            this.processInstanceList(countDownShow);
            // 缓存处理后的设备列表到 Vuex
            this.SET_INSTANCELIST(this.InstanceList);
            this.SET_HOMEDATA_FETCHTIME(Date.now());
            if (res.data.length <= 0) {
              this.buyShow = true;
            } else {
              this.integer = 1;
            }
            this.instancelistNed();
          } else if (res.code == 401) {
            this.buyShow = true;
            localStorage.removeItem("token");
            localStorage.removeItem("data");
          }
        })
        .catch(() => {
          this.delay = true;
        });
    },
    // 根据设备数量调整宫格显示
    adjustGongge() {
      const show = localStorage.getItem("homeMessage");
      const arrLength = this.InstanceList.length;
      // 宫格模式 -> 所需最少设备数
      const GONGGE_MIN_DEVICES = { 4: 2, 9: 5, 16: 10 };
      if (GONGGE_MIN_DEVICES[show] && arrLength < GONGGE_MIN_DEVICES[show]) {
        localStorage.removeItem("homeMessage");
        this.gonggeqiehuan(1);
      } else if (show !== null) {
        this.gonggeqiehuan(Number(show));
      }
    },
    // 处理设备列表数据（倒计时、续费提示、分组续费倒计时）
    processInstanceList(countDownShow) {
      const now = new Date();
      for (const instance of this.InstanceList) {
        // 计算剩余天数
        const targetDate = new Date(instance.endTime);
        const seconds = Math.floor((targetDate - now) / 1000);
        instance.countDown = instance.expireSeconds * 1000;
        instance.remind = Math.floor(seconds / 86400);

        // 续费弹窗提示：检查本地是否已隐藏
        instance.statusShow = true;
        if (countDownShow !== null) {
          const matched = countDownShow.find((item) => item.id === instance.id);
          if (matched) {
            // 跨越阈值（1天或3天）时重新显示提示
            const crossedThreshold =
              (instance.expireSeconds < 86400 &&
                matched.expireSeconds > 86400) ||
              (instance.expireSeconds < 259200 &&
                matched.expireSeconds > 259200);
            instance.statusShow = crossedThreshold;
          }
        }

        // 分组续费倒计时对象
        if (
          instance.isAuthorized !== 1 &&
          instance.isGroupRenew &&
          instance.expireSeconds < 259200 &&
          instance.groupRenewActivityTime > 0 &&
          instance.groupRenewActivityStartTime
        ) {
          this.countDownObj = instance;
        }
      }
    },
    instancelistNed() {
      setTimeout(() => {
        if (this.countDownIconShow) {
          this.getGroupBuying();
        }
        sysConfigByConfigKey({ configKey: "new_group_buy_2026" }).then(
          (res) => {
            this.new_group_buyShow = res.data;
          }
        );
      }, 500);
    },
    // 获取活动提示
    async getactivityreminder() {
      await activityreminder().then((res) => {
        if (res.code == 200) {
          if (this.applePushShow) {
            this.$refs.sonShow.ShowClick();
            this.SET_APPLEPUSHSHOW(false);
          } else {
            this.reminder = res.data;
            this.reminder_show = res.data.show;
            this.SET_REMINDER({ reminder: res.data, show: res.data.show });
          }
        }
      });
    },
    // 活动跳转
    remintz() {
      if (this.reminder.url) {
        // location.href = this.reminder.url;
        let pageh5 = this.reminder.url.substring(
          this.reminder.url.lastIndexOf("/"),
          this.reminder.url.length
        );
        this.$router.push(pageh5);
      } else {
        switch (this.reminder.activityType) {
          case 1:
            // 1.全民推广 2.激活码 3.邀请好友 4.购买设备 5.拼团活动 6.dnf手游试玩 7.qq群 10.千人团
            this.$router.push("/agencyCentre");
            break;
          case 2:
            this.$router.push("/activationconversion");
            break;
          case 3:
            this.$router.push("/invitefriends");
            break;
          case 4:
            let _vipCode = null;
            if (
              this.reminder.vipCode == "VIP1" ||
              this.reminder.vipCode == "VIP2" ||
              this.reminder.vipCode == "VIP3" ||
              this.reminder.vipCode == "VIP4"
            ) {
              _vipCode = this.reminder.vipCode.slice(-1) - 0;
            } else {
              _vipCode = this.reminder.vipCode;
            }
            this.$router.push({
              path: "/newcloudphone",
              query: { VIP: _vipCode },
            });
            break;
          case 5:
            this.$router.push("/formGroup");
            break;
          case 20260501:
            this.$router.push("/formGroup");
            break;
          case 6:
            this.$router.push("/attemptPlay");
            break;
          case 10:
            this.$router.push("/thousandGroupBuying");
            break;
          case 11:
            this.$router.push({
              path: "/preorder",
              query: { type: 11 },
            });
            break;
          case 12:
            this.$router.push({
              path: "/preorder",
              query: { type: 12 },
            });
            break;
          case 13:
            this.$router.push({
              path: "/preorder",
              query: { type: 13 },
            });
            break;
          case 14:
            this.$router.push({
              path: "/preorder",
              query: { type: 14 },
            });
            break;
          case 7:
            location.href =
              "http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=1HSqtfJflr_eqRXMIefHixSkleP90E9_&authKey=M%2BHGZYh8wi%2F3b32qLCGn94aGlzmXQByMg6Ff2I%2BMYnC1sAGnt%2F1UJOtUTis%2FpS2A&noverify=0&group_code=462925501";
            this.reminder_show = false;
            break;
          default:
            this.reminder_show = false;
        }
      }
    },
    GroupList(List) {
      this.InstanceList = List.instanceList;
    },
    countDownJump() {
      this.$router.push({
        path: "/formGroup",
      });
    },
    CountDownClose() {
      this.SET_COUNTDOWNICONSHOW(false);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  height: 100%;
  height: 100%;
  .describeBox {
    // position: absolute;
    margin: 0 0 50px 60px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    .skipBox {
      width: 100%;
      text-align: left;
    }
    .skip {
      width: 90px;
      height: 30px;
      text-align: right;
      float: left;
      background-color: #ccc;
      color: #fff;
      border: 0;
    }
    .name {
      margin: 16px 0;
    }
    .leaveFor {
      width: 100px;
      height: 40px;
    }
    .pointImg {
      width: 80px;
    }
  }
  .block {
    background-color: #fff;
    position: absolute;
    display: inline-block;
    text-align: center;
    bottom: -8px;
    right: 32px;
    border-radius: 80px;
    img {
      width: 42px;
      height: 42px;
    }
    p {
      line-height: 13px;
      margin: 2px 0 16px 0;
      font-size: 13px;
      font-weight: 400;
      color: #666666;
    }
  }
}

/* 方法2：Webkit内核浏览器专用 */
.activeHome {
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.activeHome::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}

/* 方法3：Firefox专用方案 */
.activeHome {
  overflow: auto;
  scrollbar-width: none;
}
.home {
  width: 100%;
  margin-bottom: 50px;
  // overflow-y: auto;
  // overflow-y: auto;
  // overflow-x: hidden;
  // touch-action: manipulation;
  // -webkit-overflow-scrolling: touch;
  // scrollbar-width: none;
  // -ms-overflow-style: none;
  height: 100%;
  background-image: url("@/assets/img/homeAmend/headBack.png");
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #fff;
  &::-webkit-scrollbar {
    display: none;
  }
  .main {
    margin-top: -10px;
  }
}

.remincla {
  .webImageImgPopup {
    // width: 90%;
    background: none;
    overflow: hidden;
  }
  .remi_img {
    // max-width: calc(100vw - 32px);
    // max-height: calc(100vh - 92px);
    margin: 16px auto 16px auto;
    .webImageImg {
      width: 100%;
    }
    .remi_bt {
      background: #fff;
      padding: 16px;
      border-radius: 10px;
      .remi_btP1 {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
      }
      .remi_btP2::-webkit-scrollbar {
        width: 0; /* 宽度设为0 */
        height: 0; /* 高度设为0 */
      }
      .remi_btP2 {
        font-size: 14px;
        overflow: auto;
        max-height: 400px;
      }
    }
    img {
      border-radius: 10px 10px 10px 10px;
    }
    overflow: hidden;
  }
  .remi_guanbi {
    img {
      width: 28px;
      height: 28px;
    }
  }
}
.countDownJump {
  position: fixed;
  max-width: 414px;
  right: 0;
  bottom: 150px;
  width: 78px;
  height: 67px;
  background-image: url("../../assets/img/activity/formGroup/xuanfu_icon1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .closeCountDown {
    position: absolute;
    left: 0;
    top: -10px;
    width: 15px;
    height: 15px;
  }
}
.countDownOpenJump {
  position: fixed;
  max-width: 414px;
  right: 0;
  bottom: 150px;
  width: 78px;
  height: 67px;
  background-image: url("../../assets/img/activity/formGroup/xuanfu_icon.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .closeCountDown {
    position: absolute;
    left: 0;
    top: -10px;
    width: 15px;
    height: 15px;
  }
  .timeName {
    width: 62px;
    height: 12px;
    // background-color: #a67f5e;
    border-radius: 20px;
    line-height: 12px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    // font-size: 5px;
    font-size: 8px;
    color: #fff;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translate(-50%);
    letter-spacing: 0px;
  }
}
.channelErrorPopup {
  width: 70%;
  border-radius: 16px;
  .channelError {
    font-size: 13px;
    padding: 12px 16px 16px 16px;
    color: #2c3e50;
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }
  }
}
</style>